<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-dedication element-without-heading" id="dedication">
<div class="text" id="dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>Dedicated to the memory of</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>Marg and Mal Brierley</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>who left us far too soon.</i></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?5d1a5365